import React from "react";
import "../../styles/Accordion.css"
import AllertIscrizione from "../multitessere/AllertIscrizione";
import AllertCertificato from "../multitessere/AllertCertificato";

function NLAccordionPrezzi() {
    return (
        <div className="accordion d-flex flex-column m-auto" id="accordionFlushExample" style={{maxWidth: "50em"}}>
            <div className="accordion-item">
                <h2 className="accordion-header d-flex flex-row" id="headingOne"
                    style={{justifyContent: "center", textAlign: "center"}}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        PREZZI
                    </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne"
                     data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                        <div className="table-container">
                            <table className="table text-center m-auto" style={{width: "40em"}}>
                                <thead >
                                <tr >
                                    <th scope="col" ></th>
                                    <th scope="col" style={{width: "15%"}}>
                                        Singolo
                                    </th>
                                    <th scope="col" style={{width: "15%"}}>
                                        1 mese
                                    </th>
                                    <th scope="col" style={{width: "15%"}}>
                                        3 mesi
                                    </th>
                                    <th scope="col" style={{width: "15%"}}>
                                        6 mesi
                                    </th>
                                    <th scope="col" style={{width: "15%"}}>
                                        Stagionale
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row">Open</th>
                                    <td className={"data-cell"}>10 €</td>
                                    <td className={"data-cell"}>79 €</td>
                                    <td className={"data-cell"}>213 €</td>
                                    <td className={"data-cell"}>379 €</td>
                                    <td className={"data-cell"}>695 €</td>
                                </tr>
                                <tr>
                                    <th scope="row">Over 60</th>
                                    <td className={"data-cell"}>7 €</td>
                                    <td className={"data-cell"}>63 €</td>
                                    <td className={"data-cell"}>170,50 €</td>
                                    <td className={"data-cell"}>303 €</td>
                                    <td className={"data-cell"}>556 €</td>
                                </tr>
                                <tr >
                                    <th scope="row">Break <br/> <span style={{fontSize: "14px"}}>(12:00 - 14:00)</span></th>
                                    <td className={"data-cell"}>7 €</td>
                                    <td className={"data-cell"}>63 €</td>
                                    <td className={"data-cell"}>170,50 €</td>
                                    <td className={"data-cell"} >303 €</td>
                                    <td className={"data-cell"}>556 €</td>
                                </tr>
                                <tr>
                                    <th scope="row">Night <br/> <span style={{fontSize: "14px"}}>(18:00 - 22:00)</span></th>
                                    <td className={"data-cell"}>7 €</td>
                                    <td className={"data-cell"}>44 €</td>
                                    <td className={"data-cell"}>119,50 €</td>
                                    <td className={"data-cell"}>212 €</td>
                                    <td className={"data-cell"}>365 €</td>
                                </tr>
                                <tr>
                                    <th scope="row">11 ingressi</th>
                                    <td className={"data-cell"}></td>
                                    <td className={"data-cell"}></td>
                                    <td className={"data-cell"}>100 €</td>
                                    <td className={"data-cell"}></td>
                                    <td className={"data-cell"}></td>
                                </tr>
                                </tbody>
                            </table>
                           <br/>
                            <AllertIscrizione />
                            <br/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NLAccordionPrezzi